import React from "react";
import { Typography, Button } from "@material-ui/core";

interface mfaRecoveryProps {
  goToSignIn: any;
  coBrandingEnabled: boolean;
}

const MfaRecovery: React.FC<mfaRecoveryProps> = ({ goToSignIn }) => {
  return (
    <div style={{ textAlign: "center" }}>
      <Typography variant="h4">Lost access to your authenticator?</Typography>
      <div style={{ marginTop: "3rem" }}>
        <Typography variant="h5">Are you part of a firm?</Typography>
        <Typography variant="body2">
          Contact the admin at your firm, and request a recovery passcode. The
          recovery passcode, with instructions, will be sent to your email.
        </Typography>
      </div>
      <div style={{ marginTop: "2rem" }}>
        <Typography variant="h5">Were you invited by a firm?</Typography>
        <Typography variant="body2">
          Contact your point of contact at the firm that invited you, and
          request that they have an admin send you a recovery passcode. The
          recovery passcode, with instructions, will be sent to your email.
        </Typography>
      </div>
      <Button
        color="primary"
        variant="contained"
        style={{
          width: "22.5rem",
          marginTop: "2.5rem",
        }}
        onClick={goToSignIn}
      >
        Back to sign in
      </Button>

      <hr
        style={{
          margin: "36px auto",
        }}
      />
      <Typography variant="body2">
        Still having trouble? Contact
        <a
          href="mailto:support@suralink.com?subject=Mfa Recovery Token"
          target="_blank"
          rel="noreferrer"
          style={{ marginLeft: "0.5rem" }}
        >
          support@suralink.com
        </a>
      </Typography>
    </div>
  );
};

export default MfaRecovery;
